import _extends from "@babel/runtime/helpers/extends";
import { FieldError, useFieldError } from '@wkda/funnel-components';
import cx from 'classnames';
import React from 'react';
import { Field } from 'react-final-form';
import { useTrackInputActivation } from './hooks/useTrackInputActivation';
export function BaseField(_ref) {
  let {
    label,
    name,
    MktSelector,
    topContainerClassName,
    infoText,
    isHiddenField = false,
    renderHeader = function renderHeader(_ref2) {
      let {
        label,
        name,
        ...props
      } = _ref2;
      return /*#__PURE__*/React.createElement(BaseFieldHeader, {
        name: name,
        label: label,
        className: props.headerClassName
      });
    },
    renderFieldComponent = function renderFieldComponent(_ref3) {
      let {
        input,
        meta
      } = _ref3;
      return /*#__PURE__*/React.createElement("input", _extends({}, input, {
        className: "form-control form-control-lg"
      }));
    },
    renderError = function renderErrorField(name) {
      return /*#__PURE__*/React.createElement(FieldError, {
        name: name
      });
    },
    renderInfoText = function renderInfoTextComponent(text) {
      return Boolean(text) ? /*#__PURE__*/React.createElement("span", {
        className: "font-size-xs d-block mt-1 text-muted"
      }, text) : null;
    },
    renderContentBelow = function renderContentBelowCompont(_ref4) {
      let {
        name,
        text
      } = _ref4;
      return /*#__PURE__*/React.createElement(React.Fragment, null, renderError(name), renderInfoText(text));
    },
    renderFieldWrapper = renderFieldSideWrapper,
    disabled,
    onFieldEnabled,
    ...props
  } = _ref;
  const fieldName = "field-" + name;
  const fieldHasError = useFieldError(name);
  useTrackInputActivation(name, !disabled, onFieldEnabled);
  return /*#__PURE__*/React.createElement("div", {
    id: fieldName,
    "data-mkt-selector": MktSelector === null || MktSelector === void 0 ? void 0 : MktSelector.value,
    "data-qa-selector": MktSelector === null || MktSelector === void 0 ? void 0 : MktSelector.value,
    className: cx('carlead-creation-field-container', "carlead-creation-field-container--" + name, {
      'carlead-creation-field-container--is-hidden': isHiddenField === true && disabled,
      'carlead-creation-field-container--has-error': !disabled && fieldHasError
    }, topContainerClassName)
  }, /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    name: name,
    render: function renderField(_ref5) {
      let {
        input,
        meta
      } = _ref5;
      return renderFieldWrapper({
        fieldRenderer: renderFieldComponent,
        headerRenderer: renderHeader,
        mktSelector: MktSelector,
        belowRenderer: renderContentBelow,
        label: label,
        infoText: infoText,
        disabled,
        // @ts-expect-error
        input,
        // @ts-expect-error
        meta
      });
    }
  })));
}
export function BaseFieldHeader(_ref6) {
  let {
    label,
    name,
    className
  } = _ref6;
  return /*#__PURE__*/React.createElement("label", {
    className: cx('carlead-creation-field__label', className),
    htmlFor: name
  }, label);
}
export function renderFieldSideWrapper(_ref7) {
  let {
    fieldRenderer,
    headerRenderer,
    belowRenderer,
    label,
    infoText,
    input,
    meta
  } = _ref7;
  return /*#__PURE__*/React.createElement("div", {
    className: "carlead-creation-field carlead-creation-field-horizontal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "carlead-creation-field-horizontal__header"
  }, headerRenderer({
    label,
    name: input.name,
    headerClassName: 'carlead-creation-field-horizontal__label'
  })), /*#__PURE__*/React.createElement("div", {
    className: "carlead-creation-field__group carlead-creation-field-horizontal__group"
  }, fieldRenderer({
    input,
    meta
  }), belowRenderer({
    name: input.name,
    text: infoText
  })));
}
export function renderFieldVerticalWrapper(_ref8) {
  let {
    fieldRenderer,
    headerRenderer,
    label,
    infoText,
    belowRenderer,
    input,
    meta
  } = _ref8;
  return /*#__PURE__*/React.createElement("div", {
    className: "carlead-creation-field"
  }, headerRenderer({
    label,
    name: input.name
  }), /*#__PURE__*/React.createElement("div", {
    className: "carlead-creation-field__group"
  }, fieldRenderer({
    input,
    meta
  }), belowRenderer({
    name: input.name,
    text: infoText
  })));
}